import React from "react";
import { useOktaAuth } from "@okta/okta-react";
import AppBar from "@material-ui/core/AppBar";
import Typography from "@material-ui/core/Typography";
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import { Helmet } from "react-helmet";
import textureBarImage from "../../assets/images/app_bar_texture.png";
import { ReactComponent as NielsenSq } from "../../assets/svg/n_square.svg";
import cx from "classnames";
import useNavBarStyles, { enhanceMenu } from "./NavBar.style"
import { useHistory } from "react-router-dom";
import IconButton from "@material-ui/core/IconButton";
import HomeOutlinedIcon from '@material-ui/icons/HomeOutlined';
import DescriptionOutlinedIcon from '@material-ui/icons/DescriptionOutlined';
import logo from "../../assets/images/logo.png"


const AppTexture = () => {
    const classes = useNavBarStyles();

    return (
        <div className={classes.textureRoot} >
            <img src={textureBarImage} className={classes.AppBarTexture} alt={''} />
        </div>
    )
}

const NielsenIcon = _ => {
    const classes = enhanceMenu();
    return (
        <div className={cx(classes.rightIcons, classes.lrPad)}>
            <NielsenSq height={24} />
        </div>
    )
}

function NavBar(props) {
    let history = useHistory();
    const { openNewReport, navToStatus } = props;
    const { authState, authService } = useOktaAuth();
    const [userInfo, setUserInfo] = React.useState(null);
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [userNameInitials, setUserNameInitials] = React.useState(null);
    const classes = useNavBarStyles();

    React.useEffect(() => {
        if (!authState.isAuthenticated) {
            setUserInfo(null);
        } else if (userInfo === null) {
            authService.getUser().then(info => {
                setUserInfo(info);
                if (info ?.given_name && info ?.family_name) {
                    setUserNameInitials(info.given_name[0] + info.family_name[0])
                }
                else if (info ?.given_name) {
                    setUserNameInitials(info.given_name[0])
                }
                else if (info ?.family_name) {
                    setUserNameInitials(info.family_name[0])
                }
            });
        }
    }, [authState, authService]);
    const openMenu = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    const handleLogout = async () => {
        handleClose();
        authService._oktaAuth.tokenManager.clear();
        authService.clearAuthState();
        history.push("/logout")
    };

    return (
        <div>
            <Helmet title={"ESPN"} />
            {!authState.isPending && <><AppTexture />
                <AppBar position="relative" color="default" className={classes.appBar} >
                    <Typography variant="h6" test-id={"MVNielsen_title"} color="inherit" noWrap className={classes.header} >
                        <img src={logo} alt={'ESPN'} style={{ height: 40 }} />
                    </Typography>
                    <div className={classes.actionIconsToolBar}>
                        {userInfo &&
                            <>
                                <IconButton onClick={e => navToStatus(true)} title={"Optimization Report Center"}>
                                    <DescriptionOutlinedIcon />
                                </IconButton>
                                <IconButton onClick={e => openNewReport(true)} title={"Home"}>
                                    <HomeOutlinedIcon />
                                </IconButton>
                            </>
                        }
                        {userNameInitials &&
                            <IconButton onClick={openMenu}>
                                <Typography>
                                    {userNameInitials}
                                </Typography>
                            </IconButton>
                        }
                        <NielsenIcon />
                    </div>
                    <Menu
                        anchorEl={anchorEl}
                        keepMounted
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'center',
                        }}
                        transformOrigin={{
                            vertical: 'bottom',
                            horizontal: 'center',
                        }}

                        open={Boolean(anchorEl)}
                        onClose={handleClose}
                    >
                        <MenuItem onClick={handleLogout}>Logout</MenuItem>
                    </Menu>
                </AppBar></>}
        </div>
    )
}

export default NavBar;